import PropTypes from 'prop-types';
import { Children } from 'react';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UILink from 'UIComponents/link/UILink';
import UILoadingOverlay from 'UIComponents/loading/UILoadingSpinner';
import UIPanelBody from 'UIComponents/panel/UIPanelBody';
import UIPanelSection from 'UIComponents/panel/UIPanelSection';
import AccountManager from '../../records/AccountManager';
import ContractManager from '../../records/ContractManager';
import EscalateToSelect from '../fields/EscalateToSelect';
import Escalation from '../../records/Escalation';
import { View } from 'foundations-components/transitional/components/View';

// @ts-expect-error ts-migrate(2565) FIXME: Property 'defaultProps' is used before being assig... Remove this comment to see the full error message
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const STARTER_PLAYBOOK_URL = 'https://wiki.hubspotcentral.net/pages/viewpage.action?pageId=503887568';
function EscalationPanelBody(props) {
  const renderStarterPortalNote = () => {
    if (props.isStarterPortal) {
      return /*#__PURE__*/_jsx(FormattedJSXMessage, {
        "data-test-id": "escalation-panel-body-starter-note",
        message: "app.escalations.panel.body.starterNote_jsx",
        elements: {
          UILink
        },
        options: {
          href: STARTER_PLAYBOOK_URL,
          target: '_blank'
        }
      });
    }
    return null;
  };
  return /*#__PURE__*/_jsxs(UIPanelBody, {
    children: [props.error ? props.error : null, props.isLoading ? /*#__PURE__*/_jsx(UILoadingOverlay, {
      "data-test-id": "escalation-panel-body-loading-overlay",
      grow: true,
      layout: "centered"
    }) : /*#__PURE__*/_jsxs(UIPanelSection, {
      style: {
        padding: '0.75rem 1.5rem 0.75rem 1.5rem'
      },
      children: [/*#__PURE__*/_jsx(View, {
        marginBlockEnd: "400",
        as: "div",
        children: /*#__PURE__*/_jsx(EscalateToSelect, {
          accountManager: props.accountManager,
          contractManager: props.contractManager,
          "data-test-id": "escalation-panel-body-escalate-to-select",
          isSaving: props.isSaving,
          isStarterPortal: props.isStarterPortal,
          onSelect: escalationType => props.onUpdate(props.escalation.set('type', escalationType)),
          selectedOption: props.escalation.type
        })
      }), Children.only(props.children), renderStarterPortalNote()]
    })]
  });
}
EscalationPanelBody.propTypes = {
  accountManager: PropTypes.instanceOf(AccountManager),
  children: PropTypes.node,
  contractManager: PropTypes.instanceOf(ContractManager),
  error: PropTypes.node,
  escalation: PropTypes.instanceOf(Escalation).isRequired,
  isLoading: PropTypes.bool,
  isSaving: PropTypes.bool,
  isStarterPortal: PropTypes.bool,
  onUpdate: PropTypes.func.isRequired
};

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
EscalationPanelBody.defaultProps = {
  accountManager: undefined,
  children: /*#__PURE__*/_jsx("div", {}),
  contractManager: undefined,
  error: null,
  isLoading: false,
  isSaving: false,
  isStarterPortal: false
};
export default EscalationPanelBody;